<template>
    <cadastro-simples-form
        endpoint="almox-grupo"
        rota-base="/admin/almox-grupo"
        titulo-singular="Grupo">
    </cadastro-simples-form>
</template>
<script>
import CadastroSimplesForm from '@/components/cadastros-auxiliares/cadastro-simples-form.vue'
export default { components: { CadastroSimplesForm } }
</script>
